import Vue from 'vue'
import Vuex from 'vuex'
import axios from './helpers/axios'
import VuexPersistence from 'vuex-persist'
import { isMobile } from "./helpers/helpers";

Vue.use(Vuex)

const state = {
    menu_items: [],
    startup_data: {},
    post_list: [],
    featured_posts: [],
    slide_items: [],
    block_items: [],
    recent_post_cover: {},
    recent_posts: [],
    most_popular_post_cover: {},
    most_popular_posts: [],
    most_used_keywords_post: [],
    tech_items: [],
    tech_items_cover: {},
    posts: [],
    post: {},
    related_posts: [],
    page: {},
    post_type: '',
    loading: false,
    pagination: {},
    banners: [],
    gbanners: [],
    //auth
    user: {},
    token: null,
    post_types: [],
    post_details: {},
    post_filters: {
        q: '',
        date_from: '',
        date_to: '',
        user_id: '',
        menu_id: 1,
        type: '',
    },
    most_used_keywords: [],
    google_user: {},
    posts_loaded: false,
    message: [],
}

const actions = {
    getMenuItems({commit}) {
        axios.get('/api/menu-items').then((response) => {
            commit('setMenuItems', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting menu items: '+e);
        });
    },
    getStartupData({commit}) {
        commit('setLoadingStatus', true);
        axios.get('/api/startup').then((response) => {
            commit('setStartupData', response.data);
            commit('setMostPopularPosts', response.data);
            commit('setTechItems', response.data);
            commit('setFeaturedPosts', response.data);
            commit('setRecentPosts', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting startup data: '+e);
        });
    },
    getPostList({commit}, data) {
        commit('setLoadingStatus', true);
        axios.get('/api/post-list/'+data.menu_path + (data.page? '?page=' + data.page : '')).then((response) => {
            commit('setPostList', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting post list data: '+e);
        });
    },
    getPost({commit}, post_shortname) {
        commit('setLoadingStatus', true);
        axios.get('/api/post/'+post_shortname).then((response) => {
            commit('setPost', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting post data: '+e);
        });
    },
    getPostByID({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoadingStatus', true);
            axios.get('/api/posts/'+payload.id).then((response) => {
                commit('setPostDetails', response.data);
                commit('setLoadingStatus', false);
                resolve(response.data);
            }).catch((e) => {
                console.log('an error occurred while getting post data: '+e);
                commit('setLoadingStatus', false);
                reject(e);
            });
        })
    },
    getRelatedPosts({commit}, post_shortname) {
        axios.get('/api/post/related-posts/'+post_shortname).then((response) => {
            commit('setRelatedPosts', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting related post data: '+e);
        });
    },
    getArticle({commit}, shortname) {
        commit('setLoadingStatus', true);
        return new Promise((resolve, reject) => {
            axios.get('/api/article/'+shortname).then((response) => {
                commit('setArticle', response.data);
                resolve(response.data);
            }).catch((e) => {
                console.log('an error occurred while getting post data: '+e);
            });
        })
    },
    getMostUsedKeywordsPosts({commit}, menu_path) {
        axios.get('/api/post-list/most-used-keywords/'+menu_path).then((response) => {
            commit('setMostUsedKeywordsPosts', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting most used keyword posts: '+e);
        });
    },
    getMostPopularPosts({commit}, post_shortname) {
        axios.get('/api/post-list/most-popular/'+post_shortname).then((response) => {
            commit('setMostPopularPosts', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting most popular posts: '+e);
        });
    },
    getRecentPosts({commit}, post_shortname) {
        axios.get('/api/post-list/recent/'+post_shortname).then((response) => {
            commit('setRecentPosts', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting recent posts: '+e);
        });
    },
    searchByTag({commit}, data) {
        commit('setLoadingStatus', true);
        axios.get('/api/search/'+data.menu_path+'/'+data.tag + (data.page? '?page=' + data.page : '')).then((response) => {
            commit('setPostList', response.data);
            commit('setMostPopularPosts', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting search results for ', data, ': ex: '+e);
        });
    },
    search({commit}, data) {
        commit('setLoadingStatus', true);
        axios.get('/api/search/'+data.q + (data.page? '?page=' + data.page : '')).then((response) => {
            commit('setPostList', response.data);
            commit('setMostPopularPosts', response.data);
        }).catch((e) => {
            console.log('an error occurred while getting search result for ', data, ': ex: '+e);
        });
    },
    updateVisitors({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.put('/api/post-visitors/update/'+payload.id).then((response) => {
                resolve(response);
            }).catch((e) => {
                console.log('error while updating post visitors ', e);
                reject(e);
            });
        })
    },
    addBannerClick({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.put('/api/banners/click/'+payload.id, payload).then((response) => {
                resolve(response);
            }).catch((e) => {
                console.log('error while clicking banners ', e);
                reject(e);
            });
        })
    },
    getBanners({commit}, payload) {
        return new Promise((resolve, reject) => {
            if(payload) {
                axios.post('/api/banners', {
                    params: payload,
                    is_mobile: isMobile()
                }).then((response) => {
                    commit('setBanners', response.data.data);
                    resolve(response.data.data);
                }).catch((e) => {
                    console.log('an error occurred while getting banners: '+e);
                    reject(e);
                });
            }
        })
    },
    getGBanners({commit}, payload) {
        return new Promise((resolve, reject) => {
            if(payload) {
                axios.post('/api/gbanners', {
                    params: payload,
                    is_mobile: isMobile()
                }).then((response) => {
                    commit('setGBanners', response.data.data);
                    resolve(response.data.data);
                }).catch((e) => {
                    console.log('an error occurred while getting banners: '+e);
                    reject(e);
                });
            }
        })
    },
    //admin posts
    getPosts({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit('setLoadingStatus', true);
            commit('setPostsLoaded', false);
            axios.get('/api/admin-posts', {
                params: payload.filters,
            })
                .then((response) => {
                    commit('setPosts', response.data.data);
                    commit('setPagination', response.data.pagination);
                    commit('setLoadingStatus', false);
                    commit('setPostsLoaded', true);
                    resolve(response.data.data);
                }).catch((e) => {
                console.log('unable to get posts', e);
                commit('setLoadingStatus', false);
                reject(e);
            })
        })
    },
    addPost({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/posts/add', payload).then((response) => {

                if(response.data && response.data.status == 'ok') {
                    commit('setPostDetails', response.data.data);
                    commit(
                        (response.data.data.menu_type == 'post' ?
                            'setSuccessMessage'
                            : 'setInfoMessage'), response.data.message);

                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response.data.data);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    updatePost({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.put('/api/posts/'+payload.id, payload).then((response) => {
                if(response.data && response.data.status == 'ok') {
                    commit('setPostDetails', response.data.data);
                    commit(
                        (response.data.data.menu_type == 'post' ?
                            'setSuccessMessage'
                            : 'setInfoMessage'), response.data.message);
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response.data.data);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    deletePost({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.delete('/api/posts/' + payload.id).then((response) => {
                if(response.data && response.data.status == 'ok') {
                    commit('setSuccessMessage', response.data.message);

                    if(!payload.list) {
                        commit('setPostDetails', response.data.data);
                    } else {
                        commit('removePostFromList', payload.id);
                    }
                } else {
                    commit('setErrorMessage', response.data.message);
                }
                resolve(response);
            }).catch((e) => {
                reject(e);
            })
        });
    },
    getPostTypes({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/api/posts/types', {
                params: payload,
            })
                .then((response) => {
                    commit('setPostTypes', response.data.data);
                    resolve(response.data.data);
                }).catch((e) => {
                console.log('unable to get postTypes', e);
                reject(e);
            })
        })
    },
    getMostUsedKeywords({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/api/posts/most-used-keywords/'+payload.menu_path, {
                params: payload,
            })
                .then((response) => {
                    let kws = [];

                    if(response.data.most_used_keywords) {
                        kws = Object.keys(response.data.most_used_keywords);
                    }
                    commit('setMostUsedKeywords', kws);
                    resolve(kws);
                }).catch((e) => {
                console.log('unable to get most used keywords', e);
                reject(e);
            })
        })
    },
    setLoadingStatus(state, payload) {
        state.loading = payload;
    },
    //auth
    login({commit}, data){
        return new Promise((resolve, reject) => {
            //get token first
            axios.post('/api/login', data).then((response) => {
                if(response.data) {
                    commit('setOnLogoutProgress', false);
                    commit('setToken', response.data.access_token);

                    axios.get('/api/user').then((usr) => {
                        commit('setUser', usr.data.data);
                    });

                    resolve(response);
                }else{
                    resolve({});
                }

            }).catch((err) => {
                console.log('login err', err.message);
                reject(err);
            });
        })
    },
    getCurrentUser({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/api/user').then((response) => {
                if(response.data && response.data.data) {
                    resolve(response.data.data);
                } else {
                    reject();
                }

            }).catch((e) => {
                reject(e);
            })
        })
    },
    logout({commit}){
        return new Promise((resolve, reject) => {
            axios.post('/api/logout').then((response) => {
                if(response.data){
                    commit('setUser', null);
                    commit('setOnLogoutProgress', true);
                    commit('setToken', null);
                    resolve(response.data);
                }
            }).catch((err) => {
                reject(err);
                commit('setOnLogoutProgress', false);
                console.log('logout error', err);
            });
        });
    },

}

const mutations = {
    setMenuItems (state, data) {
      state.menu_items = data;
    },
    setStartupData (state, data) {
        state.startup_data = data;
        state.featured_posts = data.featured_posts;
        state.recent_posts = data.recent_posts;
        state.tech_items = data.tech_items;
        state.loading = false;
    },
    setPostList (state, data) {
        state.post_list = data;
        state.posts = data.posts.data;
        state.pagination = data.posts.pagination;

        state.post_type = data.post_type;
        state.loading = false;
    },
    setPost (state, data) {
        state.post = data.post;
        state.loading = false;
    },
    setRelatedPosts (state, data) {
        state.related_posts = data.related_posts;
    },
    setArticle (state, data) {
        state.article = data.article;
        state.loading = false;
    },
    setFeaturedPosts (state, data) {
        state.featured_posts = data.featured_posts.data;
        state.slide_items = data.featured_posts.data.splice(0, 7);
        state.block_items = data.featured_posts.data;
    },
    setMostUsedKeywordsPosts (state, data) {
        state.most_used_keywords_post = data.posts;
    },
    setMostPopularPosts (state, data) {
        if(data && data.most_popular_posts.data) {
            state.most_popular_post_cover = data.most_popular_posts.data[0];
            state.most_popular_posts = data.most_popular_posts.data.splice(1, data.most_popular_posts.data.length);
        }
    },
    setTechItems (state, data) {
        if(data && data.tech_items.data) {
            state.tech_items_cover = data.tech_items.data[0];
            state.tech_items = data.tech_items.data.splice(1, data.tech_items.data.length);
        }
    },
    setRecentPosts (state, data) {
        if(data && data.recent_posts.data) {
            state.recent_post_cover = data.recent_posts.data[0];
            state.recent_posts = data.recent_posts.data.splice(1, data.recent_posts.data.length);
        }
    },
    setLoadingStatus (state, data) {
        state.loading = data;
    },
    setBanners(state, payload) {
        state.banners = payload;
    },
    setGBanners(state, payload) {
        state.gbanners = payload;
    },
    //admin posts
    setPosts(state, payload) {
        if(payload) {
            state.posts = payload;
        } else {
            state.posts = [];
        }
    },
    setPostDetails(state, payload) {
        state.post_details = payload;
    },
    removePostFromList(state, payload) {
        state.posts.splice(state.posts.indexOf(state.posts.find(inv => inv.id == payload)), 1);
    },
    setPostFilters(state, payload) {
        state.post_filters = payload;
    },
    setPostTypes(state, payload) {
        state.post_types = payload;
    },
    setMostUsedKeywords(state, payload) {
        state.most_used_keywords = payload;
    },
    setGoogleUser(state, payload) {
        state.google_user = payload;
    },
    setPostsLoaded(state, payload) {
        state.posts_loaded = payload;
    },
    setPagination(state, data) {
        state.pagination = data;
    },
    setOnLogoutProgress(state, data) {
        state.onLogoutProgress = data;
    },
    //auth
    setUser(state, user){
        state.user = user;
    },
    setToken(state, payload) {
        state.token = payload;
    },
    setErrorMessage(state, message) {
        state.message = [];
        state.message.push({
            id: Math.ceil(Math.random()*10),
            color: 'bg-danger',
            message: message,
            top: 'top',
            type:'error',
        });
    },
    setSuccessMessage(state, message) {
        state.message = [];
        state.message.push({
            id: Math.ceil(Math.random()*10),
            color: 'bg-success',
            message: message,
            type:'success',
        });
    },
    setInfoMessage(state, message) {
        state.message = [];
        state.message.push({
            id: Math.ceil(Math.random()*10),
            color: 'bg-primary',
            message: message,
            type:'info',
        });
    },
    clearMessage(state) {
        state.message = [];
    },
}

const getters = {
    getMenuItems: (state) => state.menu_items,
    getFeaturedPosts: (state) => state.featured_posts,
    getMostUsedKeywordsPosts: (state) => state.most_used_keywords_post,
    getSlideItems: (state) => state.slide_items,
    getBlockItems: (state) => state.block_items,
    getRecentPostCover: (state) => state.recent_post_cover,
    getRecentPosts: (state) => state.recent_posts,
    getMostPopularPostCover: (state) => state.most_popular_post_cover,
    getMostPopularPosts: (state) => state.most_popular_posts,
    getTechItemsCover: (state) => state.tech_items_cover,
    getTechItems: (state) => state.tech_items,
    getPostList: (state) => state.post_list,
    getPosts: (state) => state.posts,
    getPost: (state) => state.post,
    getRelatedPosts: (state) => state.related_posts,
    getArticle: (state) => state.article,
    getPostType: (state) => state.post_type,
    getDomainPath(state) {
        return window.location.href;
    },
    getLoadingStatus: (state) => state.loading,
    getPagination: (state) => state.pagination,
    getBannerItems: (state) => state.banners,

    //admin posts
    posts: state => state.posts,
    postDetails: state => state.post_details,
    postFilters: state => state.post_filters,
    postTypes: state => state.post_types,
    mostUsedKeywords: state => state.most_used_keywords,
    googleUser: state => state.google_user,
    postsLoaded: state => state.posts_loaded,
    loading: state => state.loading,
    isLogoutProgress: state => state.onLogoutProgress,

    //auth
    token: state => state.token,
    user(state) {
        if(state.user !== undefined) {
            return state.user;
        }

        return {
            ID: '',
            first_name: '',
            last_name: '',
        }
    },
    userID(state) {
        if(state.user !== undefined) {
            return state.user.id;
        }
    },
    isAdmin(state) {
        if(state.user !== undefined) {
            return state.user.is_admin;
        }
    },
    getMessage(state) {
        if(state.message) {
            return state.message;
        }
    },
}

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

export default new Vuex.Store({
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
    plugins: [vuexLocal.plugin]
})
